import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const whyChooseUsData = [
  { id: 1, title: '5+ Years Experience', description: 'Proven track record with 25+ successful AI projects delivered' },
  { id: 2, title: 'AI Expertise', description: 'Deep expertise in AI Models, machine learning, Data & cloud infrastructure' },
  { id: 3, title: '24/7 Support', description: 'Round-the-clock assistance whenever you need help' },
  { id: 4, title: '100% Client Satisfaction', description: "We don't stop until you're completely happy with the results" },
  { id: 5, title: 'Scalable Solutions', description: 'AI systems built to grow with your business needs' },
  { id: 6, title: 'Cutting-Edge Tech', description: 'Latest AI technologies and frameworks for optimal performance' }
];

const statsData = [
  { label: 'Success Projects', value: '25+' },
  { label: 'AI Experts', value: '20+' },
  { label: 'Client Satisfaction', value: '100%' },
  { label: 'Support Available', value: '24/7' }
];

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Why Choose AION WISE?</h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            We're not just another AI agency. Here's what makes us different
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {whyChooseUsData.map((item) => (
            <div
              key={item.id}
              className="bg-gray-800 border border-gray-700 rounded-xl p-8 hover:border-orange-500 transition-all duration-300 group"
            >
              <CheckCircle2 className="w-12 h-12 text-orange-400 mb-4 group-hover:scale-110 transition-transform" />
              <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
              <p className="text-gray-400">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {statsData.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2 bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">
                {stat.value}
              </div>
              <div className="text-gray-400 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;